import React from "react";
import { MessageCircle } from "lucide-react";

const BookingComButton = () => {
    return (
        <a
 
            href={`https://www.booking.com/hotel/id/villa-alam-klungkung-regency.en-gb.html`}
            target="_blank"
            rel="noreferrer"
            data-testid="bookincom-float-btn"
            aria-label="Booking.com"
            className="fixed bottom-24 right-6 lg:bottom-20 z-50 group flex items-center gap-3 pl-4 pr-5 py-2.0 rounded-full bg-[#273B7D] text-white shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:shadow-[0_12px_32px_rgba(37,211,102,0.55)] hover:scale-[1.03] active:scale-100 transition-all duration-300"
        >
            <span className="relative flex items-center justify-center">
                <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
                <MessageCircle
                    size={20}
                    strokeWidth={2}
                    className="relative"
                    fill="white"
                />
            </span>
            <span className="text-xs tracking-[0.18em] uppercase font-medium hidden sm:inline">
                Bookin.com
            </span>
        </a>
    );
};

export default BookingComButton;
